import { gql } from "@apollo/client";

export const Get_Statuses = gql`
  query {
    leadStatuses {
      id
      name
      sortOrder
      isDefault
    }
  }
`;

export const Get_Lead_Sources = gql`
  query getLeadSorces($order: [LeadSourceSortInput!]) {
    leadSources(order: $order) {
      id
      name
      sortOrder
    }
  }
`;

export const Get_Preferred_Contact = gql`
  query {
    preferredContact {
      id
      name
    }
  }
`;

export const Get_Users = gql`
  query GetUsers($companyId: Int!, $searchText: String!) {
    users(companyId: $companyId, searchText: $searchText) {
      email
      id
      displayName
      username
      role
    }
  }
`;
export const Get_System_Users = gql`
  query GetSystemUsers {
    systemUsers {
      items {
        id
        displayName
        userName
        ssoEmail
        phone
        isDeleted
      }
    }
  }
`;

export const Get_Languages = gql`
  query GetLanguages($searchText: String!) {
    languages(searchText: $searchText) {
      id
      name
    }
  }
`;
export const Validate_Number = gql`
  query VaildateNumber($phone: String!, $countryCode: String!) {
    leadsGrid(
      where: {
        and: [{ phone: { eq: $phone } }, { countryCode: { eq: $countryCode } }]
      }
    ) {
      items {
        countryCode
        phone
        id
      }
    }
  }
`;
export const Validate_Email = gql`
  query ValidateEmail($email: String!) {
    leadsGrid(where: { email: { eq: $email } }) {
      items {
        email
        id
      }
    }
  }
`;
export const Placeholder_Query = gql`
  query PlaceholderQuery {
    __typename
  }
`;
